import React from 'react'
import PropTypes from 'prop-types'

import { 
    useForm, 
    // Controller
} from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

function MLocation(props) {
    const {
        onSubmit,
        onAgree,
        onClose,
        ciudad,
        setCiudad,
        setCiudadText,
        estrato,
        setEstrato,
        setEstratoText,
        listCiudades
    }= props

    const schemaFilter = yup.object().shape({
        // rangeMin: 
        //     yup.number()
        //         .typeError('El rango minimo solo puede contener números')
        //         .min(10, 'El rango minimo debe ser igual o mayor que 10'),
    });

    const { 
        handleSubmit,
    } = useForm({
        defaultValues: {
            // minPrice: '',
            // typePlay: [],
            city: -1,
            estrato: -1,
        },
        resolver: yupResolver(schemaFilter),
    });

    return (
        <div className="modalClaro mLocation">
            <form 
                onSubmit={handleSubmit(onSubmit)}
                className='mLocationMain'
            >
                <p className='mLocationTitle'>Cambiar Ubicación </p>

                <div className="mLocationSelect">

                    <label htmlFor=""> Ciudad</label>

                    <span className="select">
                        <select value={ciudad} onChange={e => {
                            setCiudad(e.target.value)
                            setCiudadText(e.target.options[e.target.selectedIndex].text)
                            }
                        }>
                            <option value='-1' disabled>Selecciona una ciudad</option>
                            {listCiudades?.map(item => (
                                <option key={item.fi_ciudad} value={item.fi_ciudad}>
                                    {item.fc_descripcion}
                                </option>
                            ))}
                            
                        </select>
                    </span>
                </div>

                <div className="mLocationSelect">

                    <label htmlFor=""> Estrato</label>

                    <span className="select">
                        <select value={estrato} onChange={e => {
                            setEstrato(e.target.value)
                            setEstratoText(e.target.options[e.target.selectedIndex].text)
                            }
                        }>
                            <option value='-1' disabled>Selecciona un estrado</option>
                            {[
                                {value: '1', label: 'Estrato 1'}, 
                                {value: '2', label: 'Estrato 2'},
                                {value: '3', label: 'Estrato 3'},
                                {value: '4', label: 'Estrato 4'},
                                {value: '5', label: 'Estrato 5'},
                                {value: '6', label: 'Estrato 6'},
                            ].map(item => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                            
                        </select>
                    </span>
                </div>
                <div className='mLocationActions'>
                    <button className='btn btnPrimario' onClick={()=>{onAgree()}}>
                        Confirmar
                    </button>

                    <a href="#!" className='textLink' onClick={()=>{onClose()}}>
                        Cancelar
                    </a>
                </div>
            </form>
        </div>
    )
}

MLocation.propTypes = {
    onSubmit: PropTypes.func,
}

MLocation.defaultProps = {
    onSubmit: ()=>{},
}

export default MLocation
